// Destaques do card da conversa na lista: urgência e conversa adiada.
import { format, isSameDay } from 'date-fns';

export const ehUrgente = conversa => conversa?.priority === 'urgent';

export const ehAdiada = conversa => conversa?.status === 'snoozed';

/**
 * Hora em que a conversa adiada volta, curta para caber no card:
 * "14:30" se for hoje, "30/09 09:00" se for outro dia, null se ela só volta
 * na próxima resposta do contato (snoozed_until vazio).
 */
export const voltaDaAdiada = (snoozedUntil, agora = new Date()) => {
  if (!snoozedUntil) return null;
  const quando = new Date(
    typeof snoozedUntil === 'number' ? snoozedUntil * 1000 : snoozedUntil
  );
  if (Number.isNaN(quando.getTime())) return null;
  return format(quando, isSameDay(quando, agora) ? 'HH:mm' : 'dd/MM HH:mm');
};
